module.exports = __webpack_public_path__ + "static/media/Screenshot1.67d6d0da.png";